import AppContainer from './App';
import reducer from './app.reducer';

/**
 * App module exports
 */
export {
    AppContainer as default,
    reducer,
};



// WEBPACK FOOTER //
// ./src/js/App/index.js